export default __webpack_public_path__ + "static/media/3233 cutlery top.29652722.png";